import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import PageContent from './PageContent'
export default class Page extends Component {

    

    render() {

        let id = this.props.match.params.id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <PageContent id={id} />
                <Footer />

            </div>


        )
    }
}
